import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { RevisionModel } from '../../../../api/api.types';
import { useTranslation } from 'react-i18next';
import { CoreApi } from '../../../../api/api.apiclient';
import AuditLog from '../../../../components/tables/AuditLog';
import { LoaderBar } from '../../../../components/forms/LoaderBar';

interface BrokerRateAuditLogLocationProps {
  code: string;
}

const BrokerRateAuditLog: React.FC<RouteComponentProps<BrokerRateAuditLogLocationProps>> =
  (props) => {

    const [ revisions, setRevisions ] = useState<RevisionModel[]>([]);
    const [ isLoading, setIsLoading ] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
      const code = props.match.params.code;
      CoreApi.BrokerRates.getBrokerRateRevisions(code)
        .then((resp) => {
          setRevisions(resp.data);
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }, [ props.match.params, t ]);

    return (
      <div className="page-content">
        <div className="row justify-content-end pb-2">
          <div className="col-12">
            <h1 className="mb-0">BrokerRate {props.match.params.code} audit log</h1>
          </div>
        </div>
        {isLoading && <LoaderBar/>}
        <AuditLog
          revisions={revisions}
          jsonFieldNames={[ 'mandatoryItems' ]}
        />
      </div>
    );
  };
export default BrokerRateAuditLog;